import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const Collection_Fragment = graphqlShopifyStorefront(`
  fragment Collection on Collection {
    handle
    title
    description
    seo {
      description
      title
    }
    updatedAt
  }
`);
